import loadable from '../../utilities/loadable'

export const EmailComposer = loadable(() => import('./EmailComposer'))
export const NewUserForm = loadable(() => import('./NewUserForm'))
export const SearchUsers = loadable(() => import('./SearchUsers'))
export const WholesalersPopover = loadable(() => import('./WholesalersPopover'))
